"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityClaimExperienceDto = void 0;
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const swagger_1 = require("@nestjs/swagger");
class OpportunityClaimExperienceDto {
}
exports.OpportunityClaimExperienceDto = OpportunityClaimExperienceDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Start date of the policy",
        example: "2023-01-01",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Policy From date must be a valid date" }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], OpportunityClaimExperienceDto.prototype, "policyFrom", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "End date of the policy", example: "2023-12-31" }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Policy To date must be a valid date" }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], OpportunityClaimExperienceDto.prototype, "policyTo", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Description of the nature of loss",
        example: "Fire",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Nature of Loss must be a valid string" }),
    tslib_1.__metadata("design:type", String)
], OpportunityClaimExperienceDto.prototype, "natureOfLoss", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Premium amount for the policy", example: 1000 }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)({}, { message: "Premium must be a valid number" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityClaimExperienceDto.prototype, "premium", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Claim amount for the policy", example: 5000 }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)({}, { message: "Claim Amount must be a valid number" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityClaimExperienceDto.prototype, "claimAmount", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Claim percentage for the policy", example: 20 }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)({}, { message: "Claim Percentage must be a valid number" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityClaimExperienceDto.prototype, "claimPercentage", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Remarks or comments about the claim experience",
        example: "No major issues",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Remarks must be a valid string" }),
    tslib_1.__metadata("design:type", String)
], OpportunityClaimExperienceDto.prototype, "remarks", void 0);
